import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { SharedListingDetailsApiService } from '@shared-listing-details/store/services/shared-listing-details-api.service';

export const listingAuthorizedGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const routeService = inject(RouteService);

    const sharedListingDetailsApiService = inject(SharedListingDetailsApiService);

    return inject(UserStoreService).getUser().pipe(
        take(1),
        switchMap(user => {
            if (user?.loginData != null) {
                return of(true);
            }

            return onUnauthorizedUser(route, sharedListingDetailsApiService, routeService);
        }));
};

const onUnauthorizedUser = (route: ActivatedRouteSnapshot, sharedListingDetailsApiService: SharedListingDetailsApiService, routeService: RouteService): Observable<boolean> => {
    const listingCode: string = route.params.id;

    return sharedListingDetailsApiService.getPublicListingCode(listingCode).pipe(
        map((code) => {
            routeService.navigate(RpcRoute.SharedListingWithCode, null, null, code).catch(() => { });

            return false;
        }),
        catchError(() => {
            routeService.navigate(RpcRoute.NotFound).catch(() => { });

            return EMPTY;
        })
    );
};
